<div *ngIf="componentLoaded" class="fixed-min-header-height pt-3 pt-md-4 pt-lg-0">
    <div class="full-width-control d-block d-lg-none">
        <!-- Sorting and filter for mobile and ipad -->
        <div class="quick-add-accordion common-accordion">

            <a href="javascript:void(0);" (click)="backButtonRedirect()" class="back-listing-btn d-block d-lg-none ml-3 back-cart" title="back">
                <svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: Sketch 61.2 (89653) - https://sketch.com -->
          <title>Combined Shape</title>
          <desc>Created with Sketch.</desc>
          <g id="SCREENS" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="210209_shopboss_cart" transform="translate(-1719.000000, -1333.000000)" fill="#D9394C"
              fill-rule="nonzero">
              <path
                d="M1726.46967,1333.46967 L1727.53033,1334.53033 L1721.811,1340.24967 L1734,1340.25 L1734,1341.75 L1721.811,1341.74967 L1727.53033,1347.46967 L1726.46967,1348.53033 L1719.46967,1341.53033 C1719.2034,1341.26406 1719.1792,1340.8474 1719.39705,1340.55379 L1719.46967,1340.46967 L1726.46967,1333.46967 Z"
                id="Combined-Shape"></path>
            </g>
          </g>
        </svg> Back
            </a>
            <accordion [isAnimated]="true" [closeOthers]="true">
                <accordion-group class="d-none d-md-block" heading="Quick Add">
                    <quick-add></quick-add>
                </accordion-group>
                <div class="accordion-header-pink">
                    <accordion-group heading="Order Details">
                        <div *ngIf="orderDetail.items_count != '0'" class="quick-add-box order-details">
                            <h3 class="d-none d-lg-block">Order Details</h3>
                            <div class="product-detail">
                                <ul>
                                    <li>
                                        <p *ngIf="orderDetail.items_count == '1'">Item</p>
                                        <p *ngIf="orderDetail.items_count != '1'">Items</p>
                                        <span>{{orderDetail.items_count}}</span>
                                    </li>
                                    <li>
                                        <p *ngIf="orderDetail.items_qty == '1'">Case</p>
                                        <p *ngIf="orderDetail.items_qty != '1'">Cases</p>
                                        <span>{{orderDetail.items_qty}}</span>
                                    </li>
                                    <li>
                                        <p>Payment Mode</p>
                                        <span>{{global_data.payment_mode}}</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="promo-status" *ngIf="orderDetail.is_discount == '1' && global_data?.price_visibility != 1">
                                <p> Promo applied: <strong>{{orderDetail.discount_description}}</strong> </p>
                            </div>

                            <div class="product-detail" *ngIf="orderDetail.is_discount == '1' && orderDetail.free_products.length > 0">
                                <ng-container *ngIf="global_data?.price_visibility != 1">
                                    <div class="order-bottom-detail" *ngFor="let product of orderDetail.free_products">
                                        <p>{{product.product_name}} <br>
                                        </p>
                                        <span>{{product.product_qty}}</span>
                                    </div>
                                </ng-container>

                                <div class="promotion-listing discount first">
                                    <h5>
                                        Net Amount:
                                    </h5>
                                    <span *ngIf="orderDetail.cart_total != undefined">£{{orderDetail.cart_total.subtotal}}</span>
                                </div>
                                <div class="promotion-listing" *ngIf='orderDetail.promotions != undefined && orderDetail.promotions.length != 0'>
                                    <h5>
                                        Promotion:
                                    </h5>
                                    <ul>
                                        <li *ngFor="let pro of orderDetail.promotions">
                                            <p>{{pro.name}}</p><span class="red" *ngIf=" global_data?.price_visibility == 1">-
                        £{{pro.discount}}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="promotion-listing discount" *ngIf=" orderDetail?.cart_total != undefined &&  global_data?.price_visibility == 1 && (orderDetail?.cart_total?.store_discount != '' && orderDetail?.cart_total?.store_discount > 0)">
                                    <h5>
                                        Discount Applied:
                                        <!-- Store Discount -->
                                    </h5>
                                    <span class="red">- £{{orderDetail.cart_total.store_discount}}</span>
                                </div>
                                <div class="promotion-listing discount" *ngIf=" global_data?.price_visibility == 1 && global_data?.vat_exempt == 0">
                                    <h5>
                                        VAT:
                                    </h5>
                                    <span *ngIf="orderDetail.cart_total != undefined ">£{{orderDetail.cart_total.vat}}</span>
                                </div>
                                <div class="promotion-listing discount total" *ngIf=" global_data?.price_visibility == 1">
                                    <h5>
                                        Total Amount:
                                    </h5>
                                    <span *ngIf="orderDetail.cart_total != undefined">£{{orderDetail.cart_total.grand_total}}</span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="orderDetail.items_count != '0' && orderDetail.is_discount == '1' && global_data?.price_visibility != 1" class="invoice-discount">
                            <img src="../../assets/images/percent-icon.svg" alt="percent-icon"> Invoice discount will be applied to these values.
                        </div>
                        <div class="available-offers" *ngIf="promotionMessage?.length > 0">
                            <h4>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21">
                  <g fill="none" fill-rule="evenodd">
                    <g fill="#D9394C" fill-rule="nonzero">
                      <g>
                        <path
                          d="M28.734 15.553c1.18-.737 2.676-.737 3.856 0 .428.271.929.401 1.434.373l.021-.001c1.39-.073 2.7.656 3.331 1.859l.007.013c.229.432.59.779 1.031.99l.012.005c1.254.61 2.014 1.88 1.937 3.237l-.001.02c-.026.478.107.95.378 1.345.779 1.137.779 2.636 0 3.773-.272.395-.404.868-.378 1.346v.018c.078 1.357-.682 2.627-1.935 3.237l-.01.005c-.444.212-.807.56-1.037.995-.636 1.212-1.944 1.941-3.335 1.868l-.02-.001c-.506-.029-1.007.102-1.435.372-1.18.738-2.676.738-3.856 0-.427-.27-.929-.4-1.434-.372h-.021c-1.393.074-2.7-.655-3.331-1.858l-.005-.01c-.229-.433-.591-.782-1.033-.993l-.013-.006c-1.254-.61-2.013-1.88-1.936-3.236l.001-.02c.026-.478-.107-.95-.377-1.345-.78-1.137-.78-2.637 0-3.774.27-.395.403-.867.377-1.345v-.019c-.078-1.357.682-2.627 1.935-3.236l.012-.006c.443-.212.805-.56 1.034-.995l.005-.009c.632-1.202 1.94-1.932 3.33-1.858h.022c.505.03 1.006-.101 1.434-.372zm3.232.99c-.798-.499-1.81-.499-2.608 0-.632.401-1.374.594-2.121.552l-.02-.001c-.934-.05-1.813.435-2.233 1.234l-.006.011c-.345.655-.892 1.182-1.56 1.502l-.01.005c-.815.382-1.32 1.217-1.278 2.116v.02c.04.737-.164 1.467-.582 2.075-.506.737-.506 1.709 0 2.445.417.609.622 1.338.582 2.075v.021c-.052.884.45 1.715 1.278 2.117l.011.005c.667.32 1.213.846 1.558 1.5l.006.011c.44.812 1.312 1.294 2.233 1.236l.021-.001c.066-.004.133-.006.199-.006.68 0 1.347.193 1.922.557.798.499 1.81.499 2.608 0 .632-.4 1.374-.593 2.121-.551h.02c.935.05 1.813-.434 2.233-1.233.35-.666.898-1.193 1.566-1.514.837-.406 1.339-1.237 1.288-2.12v-.02c-.04-.738.164-1.467.582-2.076.505-.737.506-1.708 0-2.445-.418-.608-.623-1.338-.583-2.075l.001-.02c.051-.885-.451-1.715-1.279-2.117l-.01-.005c-.667-.32-1.213-.846-1.559-1.5l-.007-.015c-.419-.797-1.294-1.281-2.232-1.232l-.02.001c-.747.041-1.489-.151-2.12-.551zm1.943 9.669c1.022 0 1.85.828 1.85 1.85 0 1.023-.828 1.851-1.85 1.851-1.023 0-1.851-.828-1.851-1.85 0-1.023.828-1.851 1.85-1.851zm1.167-5.134c.183.184.204.469.061.675l-.061.073-7.404 7.404c-.206.206-.541.206-.748 0-.183-.184-.204-.469-.061-.675l.061-.073 7.404-7.404c.206-.207.541-.207.748 0zm-1.167 6.191c-.438 0-.794.355-.794.794 0 .438.356.793.794.793.438 0 .793-.355.793-.794 0-.438-.355-.793-.793-.793zm-5.818-6.875c1.023 0 1.851.829 1.851 1.851s-.828 1.851-1.85 1.851c-1.023 0-1.852-.829-1.852-1.85 0-1.023.83-1.852 1.851-1.852zm0 1.058c-.438 0-.793.355-.793.793 0 .438.355.793.793.793.438 0 .794-.355.794-.793 0-.438-.356-.793-.794-.793z"
                          transform="translate(-1635.000000, -984.000000) translate(1615.000000, 969.000000)" />
                      </g>
                    </g>
                  </g>
                </svg> Available Offers
                            </h4>
                            <ul [ngClass]="promotionMessage?.length == 1 ? 'show' : ''" [class.show]="show">
                                <li *ngFor="let offer of promotionMessage" [ngClass]="offer.hyperlink == '' ? '' : 'offer-hyperlink'">
                                    {{offer.message}} <span>{{offer.key}}</span><span *ngIf="offer.hyperlink != ''"><a
                      href="javascript:void(0);" (click)="redirectTo(offer)">{{offer.hyperlink}}</a></span>
                                </li>
                            </ul>
                            <button class="show-more-btn" (click)="show = !show" [class.show]="show" *ngIf="promotionMessage?.length > 1">{{ show ? 'Show less': 'Show More' }}

                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="7" viewBox="0 0 11 7">
                  <g fill="none" fill-rule="evenodd">
                    <g fill="#D9394C" fill-rule="nonzero">
                      <g>
                        <g>
                          <path d="M89 9.47L90.061 10.53 84.53 16.061 79 10.53 80.061 9.47 84.53 13.939z"
                            transform="translate(-1714.000000, -1164.000000) translate(1615.000000, 969.000000) translate(20.000000, 186.000000) translate(84.530330, 12.765165) scale(1, -1) translate(-84.530330, -12.765165)" />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>

              </button>
                        </div>
                    </accordion-group>
                </div>
            </accordion>
        </div>
    </div>
    <div class="container-fluid product-lisitng-wrapper cart-lisitng-wrapper">
        <div class="row">
            <div class="col-12 fixed-width-right-column hide-accordion-heading">
                <div class="common-accordion quick-add-accordion accordion-open-default-ipad">
                    <a href="javascript:void(0);" (click)="backButtonRedirect()" class="back-listing-btn d-none d-lg-block back-cart" title="back">
                        <svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <!-- Generator: Sketch 61.2 (89653) - https://sketch.com -->
              <title>Combined Shape</title>
              <desc>Created with Sketch.</desc>
              <g id="SCREENS" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="210209_shopboss_cart" transform="translate(-1719.000000, -1333.000000)" fill="#D9394C"
                  fill-rule="nonzero">
                  <path
                    d="M1726.46967,1333.46967 L1727.53033,1334.53033 L1721.811,1340.24967 L1734,1340.25 L1734,1341.75 L1721.811,1341.74967 L1727.53033,1347.46967 L1726.46967,1348.53033 L1719.46967,1341.53033 C1719.2034,1341.26406 1719.1792,1340.8474 1719.39705,1340.55379 L1719.46967,1340.46967 L1726.46967,1333.46967 Z"
                    id="Combined-Shape"></path>
                </g>
              </g>
            </svg> Back
                    </a>
                    <accordion [isAnimated]="true" [closeOthers]="true">
                        <div class="blue-bg" *ngIf="allProductCounts.back_in_stock_product_count > 0">
                            <span class="product-count d-block d-lg-none">{{allProductCounts.back_in_stock_product_count}}
                Products</span>
                            <accordion-group heading="Back In Stock" [isOpen]="isFirstOpen">
                                <back-in-stock></back-in-stock>
                            </accordion-group>
                        </div>
                        <div class="pink-bg" *ngIf="allProductCounts.out_of_stock_product_count > 0">
                            <span class="product-count d-block d-lg-none">{{allProductCounts.out_of_stock_product_count}}
                Products</span>
                            <accordion-group heading="Out of Stock" [isOpen]="isFirstOpen">
                                <out-of-stock></out-of-stock>
                            </accordion-group>
                        </div>
                        <div class="off-white-bg">
                            <span class="product-count d-block d-lg-none">{{allProductCounts.my_cart_product_count +
                allProductCounts.sales_rep_product_count}} Products</span>
                            <accordion-group heading="My Cart" [isOpen]="isFirstOpen1">
                                <my-cart></my-cart>
                            </accordion-group>
                        </div>
                    </accordion>
                </div>
            </div>
            <div class="col-12 fixed-width-left-column">
                <div class="sticky-at-top">
                    <div class="d-none d-lg-block">
                        <quick-add></quick-add>
                        <div *ngIf=" orderDetail != undefined && orderDetail.items_count != '0'" class="quick-add-box order-details">
                            <h3 class="d-none d-lg-block">Order Details</h3>
                            <div class="product-detail pb-0">
                                <ul>
                                    <li>
                                        <p *ngIf="orderDetail.items_count == '1'">Item</p>
                                        <p *ngIf="orderDetail.items_count != '1'">Items</p>
                                        <span>{{orderDetail.items_count}}</span>
                                    </li>
                                    <li>
                                        <p *ngIf="orderDetail.items_qty == '1'">Case</p>
                                        <p *ngIf="orderDetail.items_qty != '1'">Cases</p>
                                        <span>{{orderDetail.items_qty}}</span>
                                    </li>
                                    <li>
                                        <p>Payment Mode</p>
                                        <span>{{global_data.payment_mode}}</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="promo-status" *ngIf="orderDetail.is_discount == '1' && global_data?.price_visibility != 1">
                                <p> Promo applied: <strong>{{orderDetail.discount_description}}</strong> </p>
                            </div>
                            <div class="product-detail py-0">
                                <div *ngIf="orderDetail.is_discount == '1' && orderDetail.free_products.length > 0 && global_data?.price_visibility != 1">
                                    <div class="order-bottom-detail" *ngFor="let product of orderDetail.free_products">
                                        <p>{{product.product_name}} <br>
                                        </p>
                                        <span>{{product.product_qty}}</span>
                                    </div>
                                </div>

                                <div class="promotion-listing discount first" *ngIf=" global_data?.price_visibility == 1">
                                    <h5>
                                        Net Amount:
                                    </h5>
                                    <span *ngIf="orderDetail.cart_total != undefined">£{{orderDetail.cart_total.subtotal}}</span>
                                </div>
                                <div class="promotion-listing" *ngIf='orderDetail.promotions != undefined && orderDetail.promotions.length != 0'>
                                    <h5>
                                        Promotion:
                                    </h5>
                                    <ul>
                                        <li *ngFor="let pro of orderDetail.promotions">
                                            <p>{{pro.name}}</p><span class="red" *ngIf=" global_data?.price_visibility == 1">-
                        £{{pro.discount}}</span>
                                        </li>

                                    </ul>
                                </div>
                                <div class="promotion-listing discount" *ngIf=" orderDetail.cart_total != undefined &&  global_data?.price_visibility == 1 && (orderDetail?.cart_total?.store_discount != '' && orderDetail?.cart_total?.store_discount > 0)">
                                    <h5>
                                        Discount Applied:
                                        <!-- Store Discount changes doing we are removing store_discount % 1 > 0  check because it;s giving issue for 15.00 like values
                                        but we need check for for 0.00 value only -->
                                    </h5>
                                    <span class="red">- £{{orderDetail.cart_total.store_discount}}</span>
                                </div>
                                <div class="promotion-listing discount" *ngIf=" global_data?.price_visibility == 1 && global_data?.vat_exempt == 0">
                                    <h5>
                                        VAT:
                                    </h5>
                                    <span *ngIf="orderDetail.cart_total != undefined ">£{{orderDetail.cart_total.vat}}</span>
                                </div>
                                <div class="promotion-listing discount total" *ngIf=" global_data?.price_visibility == 1">
                                    <h5>
                                        Total Amount:
                                    </h5>
                                    <span *ngIf="orderDetail.cart_total != undefined">£{{orderDetail.cart_total.grand_total}}</span>
                                </div>


                            </div>
                            <div class="review-caselint" *ngIf="orderDetail != undefined && orderDetail.items_count != '0' && orderDetail.min_cases == ''">

                                <div class="col-md-12 p-0">
                                    <button class="redirect-review-btton" *ngIf="orderDetail != undefined && orderDetail.items_count != '0' && orderDetail.min_cases == ''" (click)="redirectToReview()">
                                    Proceed to Checkout
                                  </button>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="orderDetail != undefined && orderDetail.items_count != '0' && orderDetail.is_discount == '1' && global_data?.price_visibility != 1" class="invoice-discount">
                            <img src="../../assets/images/percent-icon.svg" alt="percent-icon"> Invoice discount will be applied to these values.
                        </div>
                        <div class="available-offers" *ngIf="promotionMessage?.length > 0">
                            <h4>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21">
                  <g fill="none" fill-rule="evenodd">
                    <g fill="#D9394C" fill-rule="nonzero">
                      <g>
                        <path
                          d="M28.734 15.553c1.18-.737 2.676-.737 3.856 0 .428.271.929.401 1.434.373l.021-.001c1.39-.073 2.7.656 3.331 1.859l.007.013c.229.432.59.779 1.031.99l.012.005c1.254.61 2.014 1.88 1.937 3.237l-.001.02c-.026.478.107.95.378 1.345.779 1.137.779 2.636 0 3.773-.272.395-.404.868-.378 1.346v.018c.078 1.357-.682 2.627-1.935 3.237l-.01.005c-.444.212-.807.56-1.037.995-.636 1.212-1.944 1.941-3.335 1.868l-.02-.001c-.506-.029-1.007.102-1.435.372-1.18.738-2.676.738-3.856 0-.427-.27-.929-.4-1.434-.372h-.021c-1.393.074-2.7-.655-3.331-1.858l-.005-.01c-.229-.433-.591-.782-1.033-.993l-.013-.006c-1.254-.61-2.013-1.88-1.936-3.236l.001-.02c.026-.478-.107-.95-.377-1.345-.78-1.137-.78-2.637 0-3.774.27-.395.403-.867.377-1.345v-.019c-.078-1.357.682-2.627 1.935-3.236l.012-.006c.443-.212.805-.56 1.034-.995l.005-.009c.632-1.202 1.94-1.932 3.33-1.858h.022c.505.03 1.006-.101 1.434-.372zm3.232.99c-.798-.499-1.81-.499-2.608 0-.632.401-1.374.594-2.121.552l-.02-.001c-.934-.05-1.813.435-2.233 1.234l-.006.011c-.345.655-.892 1.182-1.56 1.502l-.01.005c-.815.382-1.32 1.217-1.278 2.116v.02c.04.737-.164 1.467-.582 2.075-.506.737-.506 1.709 0 2.445.417.609.622 1.338.582 2.075v.021c-.052.884.45 1.715 1.278 2.117l.011.005c.667.32 1.213.846 1.558 1.5l.006.011c.44.812 1.312 1.294 2.233 1.236l.021-.001c.066-.004.133-.006.199-.006.68 0 1.347.193 1.922.557.798.499 1.81.499 2.608 0 .632-.4 1.374-.593 2.121-.551h.02c.935.05 1.813-.434 2.233-1.233.35-.666.898-1.193 1.566-1.514.837-.406 1.339-1.237 1.288-2.12v-.02c-.04-.738.164-1.467.582-2.076.505-.737.506-1.708 0-2.445-.418-.608-.623-1.338-.583-2.075l.001-.02c.051-.885-.451-1.715-1.279-2.117l-.01-.005c-.667-.32-1.213-.846-1.559-1.5l-.007-.015c-.419-.797-1.294-1.281-2.232-1.232l-.02.001c-.747.041-1.489-.151-2.12-.551zm1.943 9.669c1.022 0 1.85.828 1.85 1.85 0 1.023-.828 1.851-1.85 1.851-1.023 0-1.851-.828-1.851-1.85 0-1.023.828-1.851 1.85-1.851zm1.167-5.134c.183.184.204.469.061.675l-.061.073-7.404 7.404c-.206.206-.541.206-.748 0-.183-.184-.204-.469-.061-.675l.061-.073 7.404-7.404c.206-.207.541-.207.748 0zm-1.167 6.191c-.438 0-.794.355-.794.794 0 .438.356.793.794.793.438 0 .793-.355.793-.794 0-.438-.355-.793-.793-.793zm-5.818-6.875c1.023 0 1.851.829 1.851 1.851s-.828 1.851-1.85 1.851c-1.023 0-1.852-.829-1.852-1.85 0-1.023.83-1.852 1.851-1.852zm0 1.058c-.438 0-.793.355-.793.793 0 .438.355.793.793.793.438 0 .794-.355.794-.793 0-.438-.356-.793-.794-.793z"
                          transform="translate(-1635.000000, -984.000000) translate(1615.000000, 969.000000)" />
                      </g>
                    </g>
                  </g>
                </svg> Available Offers
                            </h4>
                            <ul [ngClass]="promotionMessage?.length == 1 ? 'show' : ''" [class.show]="show">
                                <li *ngFor="let offer of promotionMessage" [ngClass]="offer.hyperlink == '' ? '' : 'offer-hyperlink'">
                                    {{offer.message}} <span>{{offer.key}}</span><span *ngIf="offer.hyperlink != ''"><a
                      href="javascript:void(0);" (click)="redirectTo(offer)">{{offer.hyperlink}}</a></span>
                                </li>
                            </ul>
                            <button class="show-more-btn" (click)="showMore()" [class.show]="show" *ngIf="promotionMessage?.length > 1">{{ show ? 'Show less': 'Show More' }}

                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="7" viewBox="0 0 11 7">
                  <g fill="none" fill-rule="evenodd">
                    <g fill="#D9394C" fill-rule="nonzero">
                      <g>
                        <g>
                          <path d="M89 9.47L90.061 10.53 84.53 16.061 79 10.53 80.061 9.47 84.53 13.939z"
                            transform="translate(-1714.000000, -1164.000000) translate(1615.000000, 969.000000) translate(20.000000, 186.000000) translate(84.530330, 12.765165) scale(1, -1) translate(-84.530330, -12.765165)" />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>

              </button>
                        </div>
                        <!-- Order detail markup -->
                    </div>
                    <div *ngIf="orderDetail != undefined && orderDetail.items_count != '0' && orderDetail.min_cases == ''"  class=" d-lg-none place-order">
                        <a href="javascript:void(0)" (click)="redirectToReview()"  title="Place Order"></a>
                        <ul>
                            <li>
                                <p>Proceed To checkout</p>
                            </li>
                            <li>
                                <img src="../../assets/images/forward-icon.svg" alt="place order">
                            </li>
                        </ul>
                    </div>

                    <div *ngIf=" orderDetail != undefined && orderDetail.items_count != '0' && orderDetail.min_cases != ''">

                        <p class="minimum-warning">{{orderDetail.min_cases_msg}}</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<ng-template #termsTemplate>
    <div class="modal-header border-0 pb-2">
        <h4 class="modal-title">Confirmation!</h4>
        <button type="button" class="close  " aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
          <g fill="none" fill-rule="evenodd">
            <g stroke="#9B9B9B" stroke-width="1.75">
              <g>
                <g>
                  <path d="M14 0L0 14M0 0L14 14"
                    transform="translate(-1190 -462) translate(695 443) translate(496 20)" />
                </g>
              </g>
            </g>
          </g>
        </svg></span>
    </button>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p>You will be redirected to the payment process.</p>
                    <input type="checkbox" id="save" (change)='termsApplied($event)'>
                    <span> <label for="save">I agree to the <a routerLink="/terms" target='_blank' title="Legal">Terms &
                condition</a></label></span>

                </div>
                <div class="button-div text-center mt-3">
                    <button class="common-button mr-3" id='confirm-payment' (click)='redirectToPayment()' disabled>Continue</button>
                    <button class="common-button ghost" (click)="bsModalRef.hide()">Cancel</button>

                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #paymentTemplate>
    <div class="modal-header border-0 pb-2">
        <h4 class="modal-title">Confirmation!</h4>
        <button type="button" class="close  " aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
          <g fill="none" fill-rule="evenodd">
            <g stroke="#9B9B9B" stroke-width="1.75">
              <g>
                <g>
                  <path d="M14 0L0 14M0 0L14 14"
                    transform="translate(-1190 -462) translate(695 443) translate(496 20)" />
                </g>
              </g>
            </g>
          </g>
        </svg></span>
    </button>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p>Do you want to make payment?</p>
                </div>
                <div class="button-div text-center mt-3">
                    <button class="common-button mr-3" (click)="bsModalRef.hide()">Cancel</button>
                    <button class="common-button ghost" (click)='redirectToPayment()'>Confirm</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<div *ngIf="!componentLoaded">Loading...</div>
